import { Component, Output, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { slideInFromBottomAnimation } from '../scss/slide-in-from-bottom-animation';

@Component({
  selector: 'app-chat-more-actions',
  templateUrl: './chat-more-actions.component.html',
  animations: [slideInFromBottomAnimation],
  encapsulation: ViewEncapsulation.None
})
export class ChatMoreActionsComponent {
  @Input()
  hasWrapUps: boolean;

  @Output()
  wrapUp: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  transfer: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  endChat: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  togglePanel: EventEmitter<any> = new EventEmitter<any>();

  public onTogglePanelClick(): void {
    this.togglePanel.emit();
  }

  public onWrapUpClick(): void {
    this.wrapUp.emit();
  }

  public onTransferClick(): void {
    this.transfer.emit();
  }

  public onEndChatClick(): void {
    this.endChat.emit();
  }

  public hasSendGroupPanelItem(): boolean {
    return this.hasWrapUps;
  }
}
